module.exports = __webpack_public_path__ + "static/media/undraw_data-reports_l2u3.e8a2e5f7.svg";